import { render, staticRenderFns } from "./ModalCreateSelection.vue?vue&type=template&id=2fe82d77&"
import script from "./ModalCreateSelection.vue?vue&type=script&lang=js&"
export * from "./ModalCreateSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports